import { QueryDocumentSnapshot } from "firebase/firestore";
import React from "react";

export interface PaginationObject {
  firstDoc?: QueryDocumentSnapshot;
  lastDoc?: QueryDocumentSnapshot;
  hasPrev: boolean;
  hasNext: boolean;
}

type PaginationProps = {
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  hasPrev: boolean;
  hasNext: boolean;
};

const SKPagination = ({ onFirst, onPrev, onNext, onLast, hasPrev, hasNext }: PaginationProps) => {
  return (
    <div className="flex items-center justify-between gap-6 p-4 text-sm">
      <div className="flex space-x-2 ">
        <button
          disabled={!hasPrev}
          className="px-4 py-2 text-black bg-white rounded disabled:bg-skseparatorgray disabled:text-skgray border-[1px] border-black"
          onClick={onFirst}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 19l-7-7 7-7M11 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          className="px-4 py-2 text-black bg-white rounded disabled:bg-skseparatorgray disabled:text-skgray border-[1px] border-black"
          onClick={onPrev}
          disabled={!hasPrev}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      </div>
      <div className="flex space-x-2">
        <button
          className="px-4 py-2 text-black bg-white rounded disabled:bg-skseparatorgray disabled:text-skgray border-[1px] border-black"
          onClick={onNext}
          disabled={!hasNext}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 " fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
        <button
          className="px-4 py-2 text-black bg-white rounded disabled:bg-skseparatorgray disabled:text-skgray border-[1px] border-black"
          onClick={onLast}
          disabled={!hasNext}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 " fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5l7 7-7 7m8-14l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SKPagination;
